import { format } from 'date-fns/format';
import { he } from 'date-fns/locale/he';

export const formatHebrew = (date: string | Date) => format(new Date(date), 'PP', { locale: he });
